import clsx from 'clsx';
import React, { ChangeEvent, useState } from 'react';
import { useForm } from '../../../../../../hooks/useForm';
import { SettingItemActions } from '../../../SettingItemActions';
import { Input } from '../../../../../../components/Input';
import { Label } from '../../../../../../components/Label';
import { SettingTag } from '../../../SettingTag';

interface Props {
  index: number;
  experienceGroup: CreateExperienceGroup;
  onRemove?(index: number): void;
  onSave?(item: CreateExperienceGroup, index: number): void;
}

interface Content extends Props {
  editing: boolean;
}

interface Form extends Content {
  values: CreateExperienceGroup;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
  updateField(field: keyof CreateExperienceGroup, value: any): void;
}
export const ExperienceGroup = (props: Props) => {
  const [editing, setEditing] = useState(false);
  const { index, onRemove = null, onSave = null, experienceGroup } = props;
  const { values, onChange, updateField } = useForm<CreateExperienceGroup>(
    experienceGroup,
    () => null
  );

  return (
    <div
      className={clsx(
        'w-full inline-flex items-center justify-between gap-4 h-14'
      )}
    >
      <EditExperienceGroup
        editing={editing}
        onChange={onChange}
        updateField={updateField}
        values={values}
        {...props}
      />
      <ExperienceGroupContent editing={editing} {...props} />
      {onRemove && onSave ? (
        <SettingItemActions
          canSave={
            (values.description ?? '').trim() !== '' &&
            (values.mediafirstId ?? '').trim() !== ''
          }
          editing={editing}
          onEdit={() => setEditing(true)}
          onRemove={() => onRemove(index)}
          onSave={() => {
            onSave(values, index);
            setEditing(false);
          }}
          onCancel={() => setEditing(false)}
        />
      ) : null}
    </div>
  );
};

const EditExperienceGroup = ({ editing, values, onChange }: Form) => {
  const defaultProps: any = {
    variant: 'contained',
    onChange: onChange,
    required: true,
  };

  if (editing === false) return null;
  return (
    <fieldset className="inline-flex items-center gap-4">
      <Input
        name="description"
        label="Description"
        value={values.description}
        {...defaultProps}
      />
      <Input
        name="mediafirstId"
        label="MediaFirst ID"
        value={values.mediafirstId}
        {...defaultProps}
      />
    </fieldset>
  );
};

const ExperienceGroupContent = ({ editing, experienceGroup }: Content) => {
  if (editing) return null;

  return (
    <>
      <SettingTag name={experienceGroup.description} color="teal" />
      <Label text="MediaFirst ID:" align="left">
        {experienceGroup.mediafirstId}
      </Label>
    </>
  );
};
